import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgCrossCircle(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.28249 11.4038L11.4038 9.28247L16 13.8787L20.5962 9.28247L22.7175 11.4038L18.1213 16L22.7175 20.5962L20.5962 22.7175L16 18.1213L11.4038 22.7175L9.28249 20.5962L13.8787 16L9.28249 11.4038Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M0.75 16C0.75 7.57766 7.57766 0.75 16 0.75C24.4223 0.75 31.25 7.57766 31.25 16C31.25 24.4223 24.4223 31.25 16 31.25C7.57766 31.25 0.75 24.4223 0.75 16ZM16 3.25C8.95837 3.25 3.25 8.95837 3.25 16C3.25 23.0416 8.95837 28.75 16 28.75C23.0416 28.75 28.75 23.0416 28.75 16C28.75 8.95837 23.0416 3.25 16 3.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCrossCircle);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
